import React, { useState, useEffect, useMemo, useCallback } from "react";
import { Link, useHistory, useParams } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useTranslation } from "react-i18next";
import { useFormik } from 'formik';
import { useQuery, useMutation } from 'react-query'
import PropTypes from 'prop-types';
import Select from 'react-select';
import { toast } from "react-toastify";
import DatePicker, { registerLocale } from 'react-datepicker';
import es from 'date-fns/locale/es';
import "react-datepicker/dist/react-datepicker.css";
import { 
  Form, 
  FormGroup, 
  Label, 
  Input, 
  InputGroup,
  FormText,
  FormFeedback,
  Container,
  Button,
  Col,
  Spinner,
  Card,
  CardBody
} from 'reactstrap';
import * as Yup from 'yup';
import clsx from 'clsx';
import { useField } from 'formik';
import styled from 'styled-components';
import InputWithLoader from '../components/InputWithLoader';
import PhoneNumberInput from '../components/PhoneNumberInput';
import Checkbox from '../components/Checkbox';
import useInterval from '../hooks/useInterval'
import useQueryParams from '../hooks/useQuery'

import { LegalParticipantSchema, IndividualParticipantSchema } from '../components/ParticipantForm'


import { fetchForm, recoverUserForm, resendUserFormDocument } from '../api/actions/forms';
import FormRecoverSent from '../images/public-form/form-recover-snet.svg';
import { fetcher } from '../api/client';

import { getMongoObjectId } from '../utils';


import { useForm } from "react-hook-form";

import { PublicFormLayout } from './PublicFormHome'
registerLocale('es', es);

function PublicForm() {
    const { t, i18n } = useTranslation('common', { useSuspense: false });

    const { formId } = useParams();
    const [hasBeenSent,setHasBeenSent] = useState(false);
    const [userFormId,setUserFormId] = useState('');

    const { handleChange, values, errors, touched, handleSubmit } = useFormik({
      initialValues: {
        email: '',
      },  
      onSubmit: async (values, actions) => {
        await mutateRecoverUserForm({
          formId,
          email: values.email
        })
        
        actions.setSubmitting(false);
      },
      enableReinitialize: true,
    })

    const { data, isLoading, isError, error } = useQuery(['form', formId], () => fetcher(fetchForm(formId, { onlyPreview: true })), {
      onSuccess: ({data}) => {
        i18n.changeLanguage(data?.language?.toLowerCase())
      },
      refetchOnWindowFocus: false
    })

    const { mutate: mutateRecoverUserForm, ...recoverUserFormState } = useMutation((payload) => fetcher(recoverUserForm(payload)), {

       onSuccess: (res) => {
        setHasBeenSent(true)
        setUserFormId(res.data._id)
       },
       onError: (error) => {
        toast.error(t(`errors.${error.message}`, t('errorMessages.generalError')))
        setHasBeenSent(false)
      },
     });

     const { mutate: resendDocumentMutate } = useMutation((payload) => fetcher(resendUserFormDocument(formId, payload.userFormId)), {
      onSuccess: (data) => {
        toast.info(t('successMessages.resentContract', {participant: data.participantEmail}), {autoClose: 3000})
      },
      onError: (err) => {
        toast.error(t(err.message))
      }
    });

    const handleResend = () => {
      if (hasBeenSent && userFormId) {
        resendDocumentMutate({userFormId: userFormId})
      }
      
    }

     console.log({errors})

    return (
        <PublicFormLayout title={data?.data?.name} image={data?.data?.tenantLogo} isLoading={isLoading} isError={isError} error={error}>
          <div className="p-4">
            {/* {t('publicForms.firstStep')} */}
              <h2 className="font-weight-bold text-center ">{hasBeenSent ? t('publicForms.linkSent') : t('publicForms.recoverDocument')}</h2>
              <p className="font-weight-bold text-center " hidden={hasBeenSent}>{t('publicForms.recoverDocumentDescription')}</p>
              <div className="p-2 mb-3" hidden={hasBeenSent}>
                <FormGroup className="mb-2">
                  <Label className="mb-1 font-weight-bold" for="email">{t('publicForms.email')}</Label>
                   <div>

                      <InputGroup>
                        <InputWithLoader
                          type="text" 
                          className="form-control" 
                          id="email"
                          name="email"
                          placeholder={t("publicForms.email_example")}
                          onChange={handleChange}  
                          value={values.email}
                          // loading={loading}
                          invalid={errors.email && touched.email}
                        />
                        <FormFeedback>{t(`errors.${errors.email}`)}</FormFeedback>
                      </InputGroup>
                   </div>
              </FormGroup>
              </div>
              { hasBeenSent && <div className="p-2 mb-3 d-flex justify-content-center">
                <img src={FormRecoverSent} alt="step1"  style={{height: 200, width: 300}} />
              </div> }
              <div className="text-center">
                <Link to={`/forms/${formId}`} component={Button} className="mx-1" color="accent" size="md" style={{width: 180}}>
                  {t('actions.cancel')}
                </Link>
                <Button className="mx-1" color="accent-100" size="md" style={{width: 180}} hidden={hasBeenSent} onClick={handleSubmit} disabled={recoverUserFormState.isLoading}>
                  {t('actions.send')}
                </Button>
                {/* <Button onClick={handleResend} color="accent-100" hidden={!hasBeenSent} className="text-underline underline-on-hover ml-2" >
                    {t('actions.resend')}
                </Button> */}
              </div>
              <div className="mt-2 text-center" hidden={hasBeenSent}>
                <Link to={`/forms/${formId}/create`} className="text-underline underline-on-hover" >
                    {t('actions.createNewDocument')}
                </Link>
              </div>
          </div>
        </PublicFormLayout>
    );
}

export default PublicForm;